import React, { useCallback } from "react";
import { type RedactedPaymentPref } from "../../common/types";
import { BasePaymentPrefDisplay } from "../BasePaymentPrefDisplay";
import { ExistingPaymentPrefDetails } from "../ExistingPaymentPrefDetails";
import { InvalidInstructionsWarning } from "../InvalidInstructionsWarning";
import { PositionListOfPaymentPref } from "../PositionList/PositionListOfPaymentPref";

export type ExistingPaymentPrefDisplayProps = {
  paymentPref: RedactedPaymentPref;
  displayPositions?: boolean;
  displayRevealDetails?: boolean;
  displayInvalidInstructionsWarning?: boolean;
};

export const ExistingPaymentPrefDisplay: React.FC<ExistingPaymentPrefDisplayProps> = ({
  paymentPref,
  displayPositions,
  displayRevealDetails,
  displayInvalidInstructionsWarning,
}: ExistingPaymentPrefDisplayProps) => {
  const renderDetails = useCallback(
    () => <ExistingPaymentPrefDetails paymentPrefId={paymentPref.id} />,
    [paymentPref.id],
  );

  return (
    <BasePaymentPrefDisplay
      paymentPref={paymentPref}
      displayRevealDetails={displayRevealDetails}
      renderDetails={renderDetails}
    >
      {displayPositions && <PositionListOfPaymentPref id={paymentPref.id} />}
      {displayInvalidInstructionsWarning && paymentPref.verificationStatus === "error" && (
        <InvalidInstructionsWarning />
      )}
    </BasePaymentPrefDisplay>
  );
};
